import learningSequenceEn from "./locales/en.json";

export const LEARNING_SEQUENCE_NS = "learningSequence" as const;

export const LearningSequenceTranslations = {
  en: {
    [LEARNING_SEQUENCE_NS]: {
      ...learningSequenceEn,
    },
  },
};
